import React from 'react';
import {ViewCollection} from "../../components/AISearch/components/ViewCollection";

export const CollectionPage = () => {
    return (
        <ViewCollection />
    );
}
